export const FETCH_ALL_FIRMS = 'fetchAll'
export const LOAD_FIRM = 'load'
export const SAVE_FIRM = 'save'

export const TRASH_FIRM = 'trash'
export const UNTRASH_FIRM = 'untrash'
export const DELETE_FIRM = 'delete'
